import { useEffect, useState } from "react";
import { Button, Card, ListGroup, Badge, Spinner } from "react-bootstrap";
import useAxiosPrivate from "../../Pages/hooks/useAxiosPrivate";
import { baseURL, RETURNRESPONSE } from "../../API/API";

export default function HeaderWithMessage({ onClose }) {
  const axiosPrivate = useAxiosPrivate();
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        setLoading(true);
        const res = await axiosPrivate.get(`${baseURL}/${RETURNRESPONSE}`);
        
        // تحقق من البيانات وتأكد من أنها مصفوفة
        const data = Array.isArray(res.data.data) ? res.data.data : [];
        setMessages(data);
      } catch (err) {
        console.error("Error fetching messages:", err);
        setMessages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [axiosPrivate]);

  //1/ لو في رسالة مختارة، اعرض كارت التفاصيل
  if (selectedMessage) {
    return (
      <Card
        className="p-4"
        style={{
          width: "600px",
          maxWidth: "90vw",
          background: "#fff",
          borderRadius: "12px",
          border: "none",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          overflow: "hidden",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="m-0">📄 تفاصيل الرسالة</h5>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setSelectedMessage(null)}
          >
            رجوع
          </Button>
        </div>
        
        <div className="border rounded p-3 bg-light mb-3">
          <h6 className="fw-bold mb-2">الرسالة الأصلية:</h6>
          <p className="m-0">{selectedMessage.originalMessage}</p>
        </div>

        <div className="border rounded p-3 bg-white">
          <h6 className="fw-bold mb-2">رد المسؤول:</h6>
          <p className="m-0" style={{ fontSize: "16px", lineHeight: "1.6" }}>
            {selectedMessage.message}
          </p>
          <small className="text-muted mt-2 d-block">
            {selectedMessage.createdAt}
          </small>
        </div>
      </Card>
    );
  }

  //1/ عرض قائمة الرسائل
  return (
    <Card
      className="p-4"
      style={{
        width: "600px",
        maxWidth: "90vw",
        background: "#fff",
        borderRadius: "12px",
        border: "none",
        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        overflow: "hidden",
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="m-0">📩 الرسائل والردود</h5>
        <Button variant="danger" size="sm" onClick={onClose}>
          إغلاق
        </Button>
      </div>

      {loading ? (
        <div className="text-center p-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">جارٍ التحميل...</span>
          </Spinner>
          <p className="mt-2">جارٍ تحميل الرسائل...</p>
        </div>
      ) : messages.length > 0 ? (
        <ListGroup variant="flush">
          {messages.map((msg, index) => (
            <ListGroup.Item
              key={index}
              action
              onClick={() => setSelectedMessage(msg)}
              className="d-flex justify-content-between align-items-start"
              style={{ cursor: "pointer", borderRight: "4px solid #FFB800" }}
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold">{msg.from}</div>
                <small className="text-muted">{(msg.message || "").substring(0, 50)}...</small>
              </div>
              <Badge bg="success" pill>
                رد
              </Badge>
            </ListGroup.Item>
          ))}
        </ListGroup>
      ) : (
        <div className="text-center p-5">
          <p className="text-muted mb-0">📭 لا توجد ردود حالياً</p>
          <small className="text-muted">سيتم عرض ردود المسؤول هنا</small>
        </div>
      )}
    </Card>
  );
}
